/* eslint-disable react/jsx-filename-extension */
/* eslint-disable camelcase */
/* eslint-disable react/no-multi-comp */
import { Box, CircularProgress, Fade } from '@material-ui/core';
import React, { Suspense, useState } from 'react';
import { geolocated } from 'react-geolocated';
import { Redirect, Route, Switch } from 'react-router-dom';

import Page from 'components/Page';
import { pageHandler } from 'utils/quickFunc';
import getDefaultTimezone from 'utils/timezone/getDefaultTimezone';
import setDefaultTimezone from 'utils/timezone/setDefaultTimezone';

import ErrorBoundary from '../Containers/Other/ErrorClass';
import { lazyPage } from 'utils/chunkReload';
import routes from '../Routes/route';
import history from '../store/history';

setDefaultTimezone(getDefaultTimezone());

const AdminLayout = lazyPage(
  () => import('./layout/AdminLayout'),
  'AdminLayout',
  { clearReloadFlagOnMount: false },
);
const Error404 = lazyPage(() => import('../Containers/Other/401'), 'Error404');

const menu = routes.map((route, index) => {
  return route.component ? (
    <Route
      exact={route.exact}
      key={index}
      name={route.name}
      path={route.path}
      render={(props) => (
        <ErrorBoundary {...props}>
          <route.component {...props} />
        </ErrorBoundary>
      )}
    />
  ) : (
    <Error404 />
  );
});

const checkAuth = () => {
  const token = localStorage.getItem('token');

  if (!token) {
    return false;
  }

  return true;
};

const AuthRoute = ({ component: Component, ...rest }) => {
  React.useEffect(() => {
    localStorage.setItem('prevPath', history.location.pathname);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history.location.pathname]);

  return (
    <Fade>
      <Route
        {...rest}
        render={(props) =>
          checkAuth() ? (
            <Page title={pageHandler()}>
              <Component {...props} {...rest} />{' '}
            </Page>
          ) : (
            <Redirect to="/" />
          )
        }
      />
    </Fade>
  );
};

const App = () => {
  const [theme, setTheme] = useState('light');

  const toggleDarkTheme = () => {
    const newPaletteType = theme === 'light' ? 'light' : 'dark';
    setTheme(newPaletteType);
    sessionStorage.setItem('theme2', JSON.stringify(newPaletteType));
  };

  React.useEffect(() => {
    localStorage.removeItem('theme');
  }, []);

  React.useEffect(() => {
    const savedTheme = sessionStorage.getItem('theme2');
    if (savedTheme) {
      setTheme({
        palette: {
          type: JSON.parse(savedTheme),
        },
      });
    }
  }, []);

  return (
    <div className="tw:min-h-screen tw:bg-gray-50">
      <Suspense
        fallback={
          <Box display="flex" justifyContent="center" p={2}>
            <CircularProgress />
          </Box>
        }
      >
        <Switch>
          {menu}
          <AuthRoute
            component={AdminLayout}
            path="/"
            setTheme={toggleDarkTheme}
            theme={theme}
          />
        </Switch>
      </Suspense>
    </div>
  );
};

export default geolocated({
  positionOptions: {
    enableHighAccuracy: true,
  },
  userDecisionTimeout: 5000,
})(App);
